import { NavigateFunction } from 'react-router-dom';

/**
 * Creates a navigation handler for activity cards
 * 
 * @param id - The activity ID to navigate to
 * @param navigate - React Router navigation function
 * @returns A click handler function that navigates to the activity details page
 */
export const createActivityNavigationHandler = (
  id: string,
  navigate: NavigateFunction
) => {
  return () => {
    navigate(`/activity/${id}`);
  };
};
